<div class="modal-header">
  <h4 class="modal-title">{{'PasswordChangeTitle' | translate}}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" >
  <ng-template [ngIf]="loading"><div class="loadingScreen"></div></ng-template>
  <alert></alert>
  <form  name="myForm" #myForm="ngForm" class="form-horizontal">
    <div class="emprez-orange-fiesta" style="font-size: larger;margin-bottom: 15px;">{{'PasswordShouldBeChanged' | translate }}</div>



    <div class="form-group">
      <label >{{'CurrentPassword' | translate}}</label>
      <input required class="form-control" [focus]="focusPassword" name="currentPassword" [(ngModel)]="currentPassword" type="password" maxlength="30">
      <!--<ng2-password-strength-bar-->
        <!--[passwordToCheck]="currentPassword"-->
        <!--[barLabel]="barLabel"-->
        <!--[barColors]="myColors">-->
      <!--</ng2-password-strength-bar>-->
    </div>
    <div style="font-size: larger;margin-bottom: 15px;" [innerHtml]="explainSecurityOfUser()"></div>

    <div class="form-group">
      <label >{{'NewPassword' | translate}}</label>
      <input required class="form-control" [focus]="focusNewPassword" name="newPassword" [(ngModel)]="newPassword" type="password" maxlength="30"
             validatePassword [minLen]="security.minSizePwd"
             [minLower]="security.minNbLowerCase"
             [minUpper]="security.minNbUpperCase"
             [minNumberDigit]="security.minNumberDigit"
             [minSpecialChar]="security.minSpecialChar"
             #pwd1="ngModel"
      >
      <ng-template [ngIf]="pwd1.errors"><div class="emprez-rouge-matador">
        {{pwd1.errors['validatePassword']}}
      </div></ng-template>

      <!--<ng2-password-strength-bar-->
        <!--[passwordToCheck]="newPassword"-->
        <!--[barLabel]="barLabel"-->
        <!--[barColors]="myColors">-->
      <!--</ng2-password-strength-bar>-->
    </div>
    <div class="form-group">
      <label >{{'RepeatNewPassword' | translate}}</label>
      <input required class="form-control" [focus]="focusNewPassword2" name="newPassword2" [(ngModel)]="newPassword2" type="password" maxlength="30">
      <!--<ng2-password-strength-bar-->
        <!--[passwordToCheck]="newPassword2"-->
        <!--[barLabel]="barLabel"-->
        <!--[barColors]="myColors">-->
      <!--</ng2-password-strength-bar>-->
    </div>



  </form>
</div>



<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="!myForm.form.valid || !isPwdValid()" (click)="onUpdate()">{{'Update' | translate}}</button>
  <button type="button" class="btn btn-link" (click)="onCancel()">{{'Cancel' | translate}}</button>
</div>

